var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCodepenLogo = function SvgIconCodepenLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.108 3.056a1 1 0 0 0-.216 0 1.8 1.8 0 0 0-.751.218L1.773 8.59a1 1 0 0 0-.523.879v6a1 1 0 0 0 .523.88l9.368 5.314.01.006.014.008a1.78 1.78 0 0 0 1.67 0l.014-.008.01-.006 9.368-5.315a1 1 0 0 0 .523-.88v-6a1 1 0 0 0-.523-.878l-9.368-5.316-.024-.013a1.8 1.8 0 0 0-.727-.205M11 5.654 4.276 9.469l3.262 1.85L11 9.355zm2 3.701V5.654l6.724 3.815-3.262 1.85zm6.724 6.114L13 19.284v-3.701l3.462-1.965zM11 19.284v-3.701l-3.462-1.965-3.262 1.85zm-7.75-5.532 2.262-1.283-2.262-1.283zm15.238-1.283 2.262-1.283v2.566zm-8.923 0L12 11.087l2.435 1.382L12 13.85z",
    clipRule: "evenodd"
  })));
};
export default SvgIconCodepenLogo;